import { CheckInTagDto } from '@careapp-group/ng-sdk';
import { CareAppListActionFactory } from '../action-factory';

class CheckInTagActions extends CareAppListActionFactory<CheckInTagDto> {
  constructor() {
    super(`CheckInTags`);
  }

  get REQUEST_FREQUENTLY_USED() {
    return `[${this.type}][Request] Frequently used`;
  }
  get RESPONSE_SUCCESS_FREQUENTLY_USED() {
    return `[${this.type}][Response][Success] Frequently used`;
  }
  get RESPONSE_FAIL_FREQUENTLY_USED() {
    return `[${this.type}][Response][Fail] Frequently used`;
  }

  RequestFrequentlyUsed() {
    return {
      type: this.REQUEST_FREQUENTLY_USED,
    };
  }
  ResponseSuccessFrequentlyUsed(payload: CheckInTagDto[]) {
    return {
      payload,
      type: this.RESPONSE_SUCCESS_FREQUENTLY_USED,
    };
  }
  ResponseFailFrequentlyUsed(payload: any) {
    return {
      payload,
      type: this.RESPONSE_FAIL_FREQUENTLY_USED,
    };
  }
}

export const CheckInTags = new CheckInTagActions();
